import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuthToken } from './useAuthToken';

const useAnalyticsStatus = () => {
  const [status, setStatus] = useState('loading');
  const [analyticsInfo, setAnalyticsInfo] = useState(null);
  const { token } = useAuthToken();

  const fetchStatus = async () => {
    try {
      setStatus('loading');
      
      // Get business_id from localStorage (following existing pattern)
      const businessId = localStorage.getItem('user_id');
      if (!businessId) {
        console.error('Business ID not found in localStorage');
        setStatus('error');
        return;
      }

      if (!token) {
        console.error('Bearer token not available');
        setStatus('error');
        return;
      }
      
      const response = await axios.get(`${process.env.REACT_APP_APIURL}analytics/status`, {
        params: {
          business_id: businessId
        },
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      if (response.data.success && response.data.data.connected === true) {
        setStatus('connected');
        setAnalyticsInfo(response.data.data);
      } else {
        setStatus('disconnected');
        setAnalyticsInfo(null);
      }
    } catch (error) {
      console.error('Analytics status error:', error);
      setStatus('error');
      setAnalyticsInfo(null);
    }
  };

  useEffect(() => {
    // Wait for token to be available
    if (!token) return;

    // Check URL parameters first
    const params = new URLSearchParams(window.location.search);
    
    if (params.get('connected') === 'true') {
      // Show success toast
      if (window.showToast) {
        window.showToast('Google Analytics connected successfully!', 'success');
      }
      // Clean URL
      window.history.replaceState({}, '', window.location.pathname);
      // Force refetch status
      fetchStatus();
      return;
    }

    if (params.get('error')) {
      const error = params.get('error');
      let message = 'Something went wrong. Please try again.';
      
      switch (error) {
        case 'auth_failed':
          message = 'Google connection failed. Please try again.';
          break;
        case 'invalid_state':
          message = 'Session error. Please try again.';
          break;
        default:
          message = 'Something went wrong. Please try again.';
      }
      
      if (window.showToast) {
        window.showToast(message, 'error');
      }
      // Clean URL
      window.history.replaceState({}, '', window.location.pathname);
    }

    fetchStatus();
  }, [token]); // Re-run when token becomes available

  const refetch = () => {
    fetchStatus();
  };

  return { status, analyticsInfo, refetch };
};

export default useAnalyticsStatus;